/*
 * Created by guandong.ni on 17/10/27.
 * 原则上所有页面继承此类，页面基类，初始化页面基本功能
 */
import 'bjxy-common'
import ClassBase from '../component/classBase';
import adjust from '../component/common/adjust';
import ajax from '../component/common/ajax.jquery';
import jsonToUrl from '../component/common/jsonToUrl';
import {getCurrentPath, getQuery} from '../component/common/uri';
import cookie from '../component/common/cookie';
import report from '../component/common/report';
import uri from '../component/common/uri';
import MtaH5 from 'mta-h5-analysis';
import getWXUnionid from "./helper/getWXUnionid";
let openh5 = uri.getQuery('openh5');
if(!/^(cardloan|xywallet):\/\//.test(openh5)){openh5=''}
class PageBase extends ClassBase {
  constructor(opts) {
    super(opts);
    this.initBaiduKeyword()
    this.initQihuKeyword()
    this.initSogoKeyword()
    this.pageInit();
    this.source_ = uri.getQuery('source') || '';
    getWXUnionid().catch(function () {})
    MtaH5.init({
      "sid":'500649721', //必填，统计用的appid
      "cid":'', //如果开启自定义事件，此项目为必填，否则不填
      "autoReport":1,//是否开启自动上报(1:init完成则上报一次,0:使用pgv方法才上报)
      "senseHash":1, //hash锚点是否进入url统计
      "senseQuery":1, //url参数是否进入url统计
      "performanceMonitor":0,//是否开启性能监控
      "ignoreParams":[] //开启url参数上报时，可忽略部分参数拼接上报
    });
    if(openh5){location.href=openh5}
  }

  pageInit() {
    this.config = {};
    require('./base.css');
    adjust();
    //解决IOS 不触发 :active
    document.addEventListener('touchstart', function() {
    }, true);

  }

  getConfig(url) {

    if (!url) {
      url = getCurrentPath() + 'config.json';
    }
    let _r = parseInt(new Date().getTime() / 1000 / 60 / 5, 10);
    url = jsonToUrl(url, {_r});
    return new Promise((resolve, reject) => {
      ajax.get(url,{},true).then(json => {
        if (typeof json === 'string') {
          json = JSON.parse(json);
        }
        this.config = json;
        resolve(json);
      }).catch((a, b, c) => {
        resolve({
          errCode: -999,
        });
      });
    });

  }

  isLogin() {
    if (cookie.get('uid') && cookie.get('skey') && cookie.get('ua')) {
      return true;
    }
    return false;
  }

  confSend(_url,param,isShowLoading) {
    return new Promise((resolve, reject) => {
      ajax.post(_url, {
        data: Object.assign({
          os: 'h5',
          _srcid: param.source,
        }, param),
      },isShowLoading).then(data => {
        if (typeof data == 'string') {data = JSON.parse(data);}
          return resolve(data);
      }).catch(e => {
        reject('网络错误，请稍候再试!');

      });
    });
  }
  confSendGet(_url,param={},isShowLoading=true) {
    return new Promise((resolve, reject) => {
      ajax.get(_url,param,isShowLoading).then((data) => {
        if (typeof data == 'string') {data = JSON.parse(data);}
        return resolve(data);
      }).catch((err) => {
        reject('网络错误，请稍候再试!');
      });
    });
  }
  /**
   * 上报初始化
   * 页面需引入：https://o8wlitxaz.qnssl.com/webClient/web-static-bj/common/reporter_min.js
   * @param softid 卡贷：5，易贷：6,精英贷：10
   */
  reportInit(opt) {
    document.cookie = `source=${this.source_};domain=xiaoying.com;Session;path=/ `;
    document.cookie = `_srcid=${this.source_};domain=xiaoying.com;Session;path=/ `;
    let obj = {
      softid:5
    };
    if(typeof opt === 'string' || typeof opt === 'number'){
      obj.softid = opt
    }
    report.init(Object.assign(obj,opt))
  }

  checkPlugin(checkFun, times = 0) {
    return new Promise((resolve, reject) => {
      if (checkFun()) {
        resolve();
      } else if (times > 20) {
        alert('组件加载出错');
        reject();
      } else {
        setTimeout(() => {
          this.checkPlugin(checkFun, ++times);
        }, 200);

      }
    });
  }
  //百度关键词留存
  initBaiduKeyword() {
  var baiduChannel = uri.getQuery("channel_content");
  if(baiduChannel) {
    var cookieDomain = window.location.host.indexOf("xiaoying.com") == -1 ? ".yingzt.com" : ".xiaoying.com";
    document.cookie = `baiduChannel=${baiduChannel};domain=${cookieDomain};Session;path=/ `;
  }
};

  //360关键词留存
  initQihuKeyword() {
  var plan     = uri.getQuery("360plan");
  var group    = uri.getQuery("360group");
  var creative = uri.getQuery("360creative");
  var keyword  = uri.getQuery("360keyword");
  var device   = uri.getQuery("360device");
  if(keyword) {//有keyword 即可落地
    var qihuChannel  = plan + "_" + group + "_" + creative + "_" + keyword + "_" + device;
    var cookieDomain = window.location.host.indexOf("xiaoying.com") == -1 ? ".yingzt.com" : ".xiaoying.com";
    document.cookie = `qihuChannel=${qihuChannel};domain=${cookieDomain};Session;path=/ `
  }
};

  //搜狗关键词留存
  initSogoKeyword() {
  var keyword  = uri.getQuery("sogokeyword");
  var creative = uri.getQuery("creative");
  if(keyword) {//三个要素同时存在才落地a
    var sogoChannel  = keyword + "_" + creative;
    var cookieDomain = window.location.host.indexOf("xiaoying.com") == -1 ? ".yingzt.com" : ".xiaoying.com";
    document.cookie = `sogoChannel=${sogoChannel};domain=${cookieDomain};Session;path=/ `
  }
};
}
export default PageBase;



// WEBPACK FOOTER //
// ./src/common/pageBase.js